import { CommonInput, RegularButton } from 'pg-ui-library';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;
  text-transform: uppercase;
  margin: 0;
  text-align: center;
`;

export const CloseIcon = styled.img`
  height: auto;
  width: 14px;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormRow = styled.div`
  display: grid;
  grid-gap: 20px;
  margin-top: 20px;
`;

export const SeeDocumentsButton = styled(RegularButton)`
  margin: 0;
  min-width: 288px;
`;

export const PercentToPayInput = styled(CommonInput)`
  background: #fff;
  border: 1px solid #dbdbdc;
`;
